<!-- 旗舰话费 -->
<template>
  <div>

    <!-- title img -->
    <div class="title">
      <div class="pannel-pay-title">
        <div style="background-color:rgb(25,118,210);height:3.4em;  line-height:3.4em;">
          <span style="font-size: 31.75px; font-weight: 700;  color: rgb(255, 255, 255); ">
            INPAY
          </span>
        </div>
      </div>
    </div>

    <!-- orderID -->
    <OrderIdComp :order-info="orderInfo" />

    <!-- time left -->
    <TimerComp2 :order-info="orderInfo" :pay-time-info="payTimeInfo" />

    <!-- pay -->
    <div class="pannel" v-if="orderInfo.orderId" style="padding: 0.5em 2em ;">
      <label class="infoContainer form-check-label" for="exampleRadios1" style="font-weight:3em;">
        <div class="items1" style="padding:0.6em;">
          <img src="/imgs/in_orig/paytm.png" style="width:3em;border-radius:3em;" />
        </div>
        <div class="items2" style="text-align:left;">
          Paytm
        </div>
        <div class="items3" style="padding:0.6em;">
          <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1" value="option1" style="zoom:200%;" checked>
        </div>
      </label>
      <label class="infoContainer form-check-label" for="exampleRadios2" style="font-weight:3em;margin-top:0.2em;">
        <div class="items1" style="padding:0.6em;">
          <img src="/imgs/in_orig/phonepe.png" style="width:3em;border-radius:3em;" />
        </div>
        <div class="items2" style="text-align:left;">
          Phonepe
        </div>
        <div class="items3" style="padding:0.6em;">
          <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios2" value="option2" style="zoom:200%;">
        </div>
      </label>
      <label class="infoContainer form-check-label" for="exampleRadios3" style="font-weight:3em;margin-top:0.2em;">
        <div class="items1" style="padding:0.6em;">
          <img src="/imgs/in_orig/gpay.png" style="width:3em;border-radius:3em;" />
        </div>
        <div class="items2" style="text-align:left;">
          Gpay
        </div>
        <div class="items3" style="padding:0.6em;">
          <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios3" value="option3" style="zoom:200%;">
        </div>
      </label>
      <label class="infoContainer form-check-label" for="exampleRadios4" style="font-weight:3em;margin-top:0.2em;">
        <div class="items1" style="padding:0.6em;">
          <img src="/imgs/in_orig/upi.png" style="width:3em;border-radius:3em;" />
        </div>
        <div class="items2" style="text-align:left;">
          UPI Apps
        </div>
        <div class="items3" style="padding:0.6em;">
          <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios4" value="option4" style="zoom:200%;">
        </div>
      </label>
      <!--唤醒按钮-->
      <div class="pannel-btn" v-if="orderInfo.upiPayBtn" style="margin-top: 1em;">
        <div style="">
          <a :href="orderInfo.schemeLink" class="btn btn-n1" style="width:90%;background-color: rgb(25, 118, 210);">PAY</a>
        </div>
      </div>
    </div>

    <!-- time tips -->
    <TimeTipsComp :order-info="orderInfo" />

    <!-- 图片广告 -->
    <div class="" style="margin-top:1em;">
      <div class="pannel-pay-title">
        <img src="/imgs/bee_b1.png" />
      </div>
    </div>
    <div class="">
      <div class="pannel-pay-title">
        <img src="/imgs/bee_b2.png" />
      </div>
    </div>

  </div>
</template>

<script>
import OrderIdComp from "@/views/comp/slot_order_id_comp";
import TimerComp2 from "@/views/comp/slot_timer_comp2";
import TimeTipsComp from "@/views/comp/slot_time_tips_comp";
//
import QRCode from "qrcode";
//
export default {
  components: {
    OrderIdComp,
    TimerComp2,
    TimeTipsComp,
  },
  props: {
    orderInfo: {
      type: Object,
      default() {
        return {};
      },
    },
    payTimeInfo: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      //
      isShow: true,
      //
      schemeLink: "",
      schemeQrImg: "",
    };
  },
  computed: {},
  created() {},
  methods: {
    //
    init() {
      // 判断地址是否为http开头的，如果是的直接跳转
      if (this.orderInfo.schemeLink) {
        if (this.orderInfo.schemeLink.startsWith("http")) {
          // 隐藏按钮
          this.isShow = false;
          // 跳转
          window.location.href = this.orderInfo.schemeLink;
          return;
        }
      }
      // 生成二维码;
      if (this.orderInfo.schemeLink) {
        QRCode.toDataURL(
          this.orderInfo.schemeLink,
          { errorCorrectionLevel: "L", margin: 1, width: 500 },
          (err, url) => {
            if (err) {
              return;
            }
            this.schemeQrImg = url;
          }
        );
      }
    },
  },
};
</script>

<style>
</style>

<style lang="scss" scoped>
</style>
